import { useCallback, useRef } from 'react'
import * as React from 'react'
import useToggle from 'hooks/useToggle'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Clickable from 'components/Common/Clickable'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import IconButton from 'LuxKit/Button/IconButton'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  selected: string
  airports: Array<string>
  className?: string
  onChange: (location: string) => void
}

function FlightDealAirportSelect(props: Props) {
  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const { selected, airports, className, onChange } = props
  const [dropdownOpen, toggleDropdown,, closeDropdown] = useToggle()

  const onSelectLocation = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const location = airports.find((code) => code === e.currentTarget.dataset.code)
    if (location) {
      onChange(location)
      closeDropdown()
    }
  }, [airports, onChange, closeDropdown])

  const onSelectAirport = useCallback(async() => {
    toggleDropdown()
  }, [toggleDropdown])

  return (
    <>
      <Clickable ref={triggerRef} onClick={onSelectAirport} className={className}>
        <HeadingTextBlock
          endIcon={
            <IconButton kind="tertiary" variant="dark" nonInteractable>
              <LineAngleDownIcon />
            </IconButton>
          }
          variant="heading2alt"
        >
          {selected}
        </HeadingTextBlock>
      </Clickable>
      <DropdownList
        size="M"
        open={dropdownOpen}
        triggerRef={triggerRef}
        anchorRef={triggerRef}
        onClose={closeDropdown}
      >
        {airports.map((airport) =>
          <ClickableListItem
            key={airport}
            size="medium"
            title={airport}
            data-code={airport}
            onClick={onSelectLocation}
            selected={selected === airport}
          />,
        )}
      </DropdownList>
    </>
  )
}

export default FlightDealAirportSelect
